// extracted by mini-css-extract-plugin
module.exports = {"main":"CategoryText_main__vM7Gl"};